module.exports = __webpack_public_path__ + "static/media/add_icon.b2fe778f.svg";